import { createParser } from 'nuqs';
import { parseAsTimestamp } from './parse-as-timestamp';

/** Parsed selection range from URL (from,to as timestamps). */
export interface SelectionRange {
  from: number;
  to: number;
}

/**
 * Parses a URL query value as a selection range "from,to" (two timestamps separated by comma).
 * Each part accepts the same format as parseAsTimestamp (numeric or ISO string).
 * Returns null when missing, empty, or when either part is invalid.
 */
function parseSelection(value: string | null | undefined): SelectionRange | null {
  if (value == null || value === '') {
    return null;
  }

  const parts = value.trim().split(',');
  if (parts.length !== 2) {
    return null;
  }

  const from = parseAsTimestamp.parse(parts[0].trim());
  const to = parseAsTimestamp.parse(parts[1].trim());

  if (from == null || to == null) {
    return null;
  }

  return { from, to };
}

/**
 * nuqs parser for logger URL param selection=from,to.
 * Used to set the stream range via a single comma-separated param.
 */
export const parseAsSelection = createParser<SelectionRange | null>({
  parse: parseSelection,
  serialize(value) {
    return value == null ? '' : `${value.from},${value.to}`;
  },
  eq(a, b) {
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;
    return a.from === b.from && a.to === b.to;
  },
});
